import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useCountdown } from '@/js/libs/hooks/useCountdown';
import { Badge } from '@/js/libs/ui/src/V2';

import { useCompanySwitchContext } from '../../context';

export const TemporaryAccessTimer = memo(function TemporaryAccessTimer() {
  const [t] = useTranslation(['components']);

  const { company, sessionExpiresAt, onCompanyChange } = useCompanySwitchContext();

  const handleExpire = useCallbackRef(() => onCompanyChange(null));

  const { min, sec } = useCountdown(sessionExpiresAt, handleExpire);

  if (!company?.temporaryAccessRequired || !sessionExpiresAt) {
    return null;
  }

  const time = `${min}:${String(sec).padStart(2, '0')}`;

  return (
    <Badge
      informative
      title={t('components:TEMPORARY_ACCESS_TIME', {
        time,
        defaultValue: 'Temporary access time {{time}}',
      })}
    />
  );
});
